import {useSelector} from 'react-redux';

import {selectIsDcxMarket} from '@/state/selectors/auth';

const useIsDcxMarket = () => useSelector(selectIsDcxMarket);

export default useIsDcxMarket;
